import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { FuseCardComponent } from '@fuse/components/card';
import { TFMService } from 'app/mock-api/tfm.service';
import { HeadingSectionType01Component } from '../../heading-section/heading_section-type01/heading_section-type01.component';
import { NgStyle } from '@angular/common';
import { FooterType03Component } from "../../../../layout/common/footer/footer-type03/footer-type03.component";

@Component({
  selector: 'app-about-type03',
  standalone: true,
  imports: [MatIconModule, FuseCardComponent, HeadingSectionType01Component, NgStyle, FooterType03Component],
  templateUrl: './about-type03.component.html',
  styleUrl: './about-type03.component.scss'
})
export class AboutType03Component {

  public view: any = {
    title: ''
  }

  constructor(public _tfmService: TFMService) {
    
    this._tfmService.getContentBySection('about').then(res => {
      this.view.page = res;
      // this._tfmService.log('content' ,this.view.page.content[0]);
      
    });
    this._tfmService.getSite().then(res => {
        this.view.site = res;

        this.view.site.profile = this._tfmService.getSiteProfile(this.view.site.profileID);
        this._tfmService.log(this.view);

      });
  }
}
